export default __webpack_public_path__ + "9374125.png";